/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

/** Common Components */
import Buttons from "../../../../../../../../components/ui/button/Buttons";
import CKEditorComponent from "../../../../../../../../components/finalForms/ui/inputs/ckEditor/CKEditor";

/** Common Services & Data Files */
import { AppIcons } from "../../../../../../../../data/appIcons";
import SwalAlert from "../../../../../../../../services/swalService/SwalService";
import ToastService from "../../../../../../../../services/toastService/ToastService";

/** RTK Query */
import { useUpdateSynergyCommentMutation } from "../../../../../../../../app/services/projectSynergyAPI";

const EditSynergyComment = ({ onSuccessPopup, commentId, onClose }) => {

  const [updateSynergyComment, {
    isLoading: isupdateSynergyCommentLoading,
    isSuccess: isSuccessupdateSynergyComment,
    data: updateSynergyCommentData,
  },] = useUpdateSynergyCommentMutation();

  useEffect(() => {
    if (isSuccessupdateSynergyComment && updateSynergyCommentData) {
      if (updateSynergyCommentData.errorMessage.includes("exists")) {
        ToastService.warning(updateSynergyCommentData.errorMessage);
        return;
      } else {
        ToastService.success(updateSynergyCommentData.errorMessage);
        onSuccessPopup();
      }
    }
  }, [isSuccessupdateSynergyComment, updateSynergyCommentData]);

  const [description, setDescription] = useState(commentId.commentText);
  const { error } = SwalAlert();

  const handleSave = () => {
    const request = {
      commentID: commentId.commentID,
      commentText: description,
    };
    if (request.commentText === "") {
      error("please enter your comment", "Validation Failed!");
    } else {
      updateSynergyComment(request);
    }
  }

  return (
    <div>
      <CKEditorComponent
        onCKEditorChange={(newData) => setDescription(newData)}
        data={commentId.commentText}
      />

      <div className="row mt-2">
        <div className="col-12">
          <div className="form-btn d-flex justify-content-end">
            <Buttons
              buttonTypeClassName="dark-btn"
              onClick={onClose}
              buttonText="Cancel"
            />
            <Buttons
              buttonTypeClassName="theme-btn ml-4"
              isLoading={isupdateSynergyCommentLoading}
              onClick={handleSave}
              buttonText="Update"
              imagePath={AppIcons.AddIcon}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditSynergyComment;
